import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
export var globalData = ref(null);
export function extractNameAndValue(dataArray) {
  if (!dataArray) return [];
  return dataArray.map(function (item) {
    return {
      name: item.name,
      value: item.value
    };
  });
}
export function updateGlobalData(newData) {
  var isExtractData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!newData || !newData.fields) {
    return;
  }
  if (isExtractData) {
    globalData.value = extractNameAndValue(newData.fields);
  }
}